import type { BaseQLMiddleware } from '@adornis/baseql/metadata/types.js';

/**
 * Marks a project operation as **deliberately** reachable without a session.
 *
 * It does nothing at runtime, and that is the point: the startup audit in `applyOperationPolicies`
 * reports every project operation with no middleware as unguarded, which would otherwise flag the
 * handful of genuinely public endpoints forever and drown out the real ones. Declaring this makes
 * the intent explicit at the registration site, where a reviewer sees it next to the resolver.
 *
 * Use it only where a logged out caller genuinely must succeed - login, password reset, the public
 * SuS registration flow - and write down why.
 *
 * @param reason why this operation is safe to expose, e.g. 'durch signiertes Einmal-Token geschuetzt'
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const publicOperationMiddleware =
  (reason: string): BaseQLMiddleware =>
  options =>
    options.next();
